import withDialog from '../../../hoc/withDialog'
import RescheduleIconUrl from '../../../assets/icons/ic_visit_blocker.svg'

const RescheduleVisitsDialog = (props: { onDismiss: () => void }) => {
  const { onDismiss } = props

  return (
    <div className="flex h-64 w-96 flex-col items-center">
      <img src={RescheduleIconUrl} className="mx-auto mt-2" />
      <h1 className="typography-body-l py-8">Tap the button below to view your scheduled visits.</h1>
      <button className="btn-small btn-primary" onClick={onDismiss} type="button">
        VIEW VISITS
      </button>
    </div>
  )
}

export default withDialog(RescheduleVisitsDialog)
